export default "__VITE_ASSET__DehkiEMN__"